<template>
  <MonitorWrapper class="ht01-device">
    <div class="row row1">
      <div>
        <span class="large">PM2.5</span>
        <small>μg/m³</small>
      </div>
      <div>
        <span class="large">二氧化碳</span>
        <small>PPM</small>
      </div>
    </div>
    <div class="row row2">
      <div>
        <span class="large">{{ cfg['PM2.5'].value }}</span>
        <level :level="cfg['PM2.5'].level" />
      </div>
      <div>
        <span class="large">{{ cfg.CO2.value }}</span>
        <div class="meter" :class="`l${cfg.CO2.level}`"></div>
      </div>
    </div>
    <div class="row row3">
      <div class="column2">
        <div class="pm1">
          <div class="name">PM1</div>
          <div class="line">
            <div>
              <span>{{ cfg.PM1.value }}</span>
              <span>μg/m³</span>
            </div>
            <div class="meter" :class="`l${cfg.PM1.level}`"></div>
          </div>
        </div>
        <div class="pm10">
          <div class="name">PM10</div>
          <div class="line">
            <div>
              <span>{{ cfg.PM10.value }}</span>
              <span>μg/m³</span>
            </div>
            <div class="meter" :class="`l${cfg.PM10.level}`"></div>
          </div>
        </div>
      </div>
      <div class="column right">
        <div class="name">TVOC</div>
        <div class="line">
          <div>
            <span>{{ cfg.TVOC.value }}</span>
            <span>mg/m³</span>
          </div>
          <div class="meter" :class="`l${cfg.TVOC.level}`"></div>
        </div>
      </div>
      <div class="column2">
        <div class="temperature">
          <span class="iconfont icon-temperature"></span>
          <span class="val">
            <span>{{ cfg.T.value }}</span>
            <small>℃</small>
          </span>
        </div>
        <div class="humidity">
          <span class="iconfont icon-humidity"></span>
          <span class="val">
            <span>{{ cfg.HUMI.value }}</span>
            <small>%</small>
          </span>
        </div>
      </div>
      <div class="column right">
        <div class="name">甲醛浓度</div>
        <div class="line">
          <div>
            <span>{{ cfg.HCHO.value }}</span>
            <span>mg/m³</span>
          </div>
          <div class="meter" :class="`l${cfg.HCHO.level}`"></div>
        </div>
      </div>
    </div>
  </MonitorWrapper>
</template>

<script>
import singleDeviceMixin from '@/mixins/singleDeviceMixin';
import Level from './components/level.vue';

export default {
  components: {
    Level
  },
  mixins: [singleDeviceMixin],
  data() {
    return {
      cfg: {
        'PM2.5': {
          name: 'pm2.5',
          unit: 'μg/m³',
          value: 0,
          level: 0
        },
        CO2: {
          name: '二氧化碳',
          unit: 'ppm',
          value: 0,
          level: 0
        },
        PM10: {
          name: 'PM10',
          value: 0,
          unit: 'μg/m³'
        },
        PM1: {
          name: 'PM1',
          value: 0,
          unit: 'μg/m³'
        },
        TVOC: {
          name: 'TVOC',
          unit: 'mg/m³',
          value: 0,
          level: 0
        },
        T: {
          name: '温度',
          unit: '℃',
          value: 0
        },
        HUMI: {
          name: '湿度',
          unit: '%',
          value: 0
        },
        HCHO: {
          name: '甲醛',
          value: 0,
          unit: 'mg/m³',
          level: 0
        }
      },
      timer: null
    };
  },
  methods: {
    setBg(flag) {
      document.querySelector('.main-content').style.background = flag ? '#000024' : 'unset';
    },
    updateData(res) {
      try {
        const { mods } = res || {};
        if (!mods) return;
        const { ht01Mod } = mods || {};
        if (!ht01Mod) return;
        const { param } = ht01Mod;
        param.forEach(e => {
          if (!this.cfg[e.name]) return;
          Object.assign(this.cfg[e.name], { value: e.value, unit: e.unit, level: e.level });
        });
      } catch (error) {
        console.error('----HT01: update failed!', error);
      }
      // console.table(JSON.parse(JSON.stringify(res.mods.ht01Mod.param)));
    }
  },
  mounted() {
    this.setBg(true);
  },
  beforeDestroy() {
    this.setBg();
    clearInterval(this.timer);
  }
};
</script>

<style lang="scss">
.ht01-device {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  user-select: none;
  .meter {
    width: 15.6vw;
    height: 1.66vw;
    &.l0 {
      background-image: linear-gradient(
        to right,
        #34eb18 33.3%,
        #687188 33.3% 66.6%,
        #63488c 66.6% 100%
      );
    }
    &.l1 {
      background-image: linear-gradient(
        to right,
        #3e7388 33.3%,
        #f8e816 33.3% 66.6%,
        #63468d 66.6% 100%
      );
    }
    &.l2 {
      background-image: linear-gradient(
        to right,
        #3e7388 33.3%,
        #687289 33.3% 66.6%,
        #e0122d 66.6% 100%
      );
    }
  }
  .row {
    display: flex;
    justify-content: space-around;
  }
  .row1 {
    align-items: flex-end;
    & > * {
      flex: 1;
      padding: 0 1vw 0 6vw;
    }
    .large {
      font-size: 2.8vw;
      margin-right: 2.5vw;
    }
    small {
      font-size: 1.9vw;
    }
  }
  .row2 {
    & > * {
      flex: 1;
      display: flex;
      align-items: baseline;
      justify-content: space-between;
      padding: 0 2vw 0 6vw;
    }
    .large {
      font-size: 5.8vw;
    }
  }
  .row3 {
    flex-wrap: wrap;
    .column {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      flex: 1;
      margin: 0.5vw;
      background: #0f2f80;
      padding: 1.5vw;
      box-sizing: border-box;
      .name {
        font-size: 2.3vw;
      }
      .line {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 2.1vw;
      }
    }
    .column2 {
      flex: 1;
      display: flex;
      min-width: 40%;
      margin: 0.5vw;
      box-sizing: border-box;
      & > * {
        background: #0f2f80;
        flex: 1;
        max-width: calc(50% - 0.5vw);
        box-sizing: border-box;
      }
      & > *:first-of-type {
        margin-right: 1vw;
      }

      .pm1,
      .pm10 {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 0 1vw;
        .name {
          font-size: 2vw;
          margin-bottom: 5px;
        }
        .line {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 1.8vw;
          .meter {
            width: 8vw;
            height: 1.2vw;
          }
        }
      }

      .humidity,
      .temperature {
        display: flex;
        align-items: center;
        .iconfont {
          font-size: 5vw;
        }
        .val {
          font-size: 3.2vw;
          small {
            font-size: 2.8vw;
          }
        }
      }
    }
    .right {
      background: linear-gradient(120deg, #0f2f80 88%, transparent 80% 100%);
      .line {
        width: 80%;
      }
    }
  }
}
</style>
